import { useModeratorStore, } from "../store/moderatorStore.ts";
import { MainPageDefault, } from "../components/features/MainPage/MainPageDefault.tsx";
import { MainPageModerator, } from "../components/features/MainPage/MainPageModerator.tsx";

/**
 * Main page of the application
 */
export function MainPage() {
  const isModerator = useModeratorStore(state => state.isModerator,);

  return (
    <>
      {isModerator ? <MainPageModerator /> : <MainPageDefault />}
    </>
  );
}

MainPage.loader = () => null;
